import { Link } from 'react-router-dom'

import type { CiContracts } from '../api/types'
import { t } from '../i18n/lingua'
import { Card } from './common'
import { BadgeStatoContratto, etichettaTipoContratto } from './contratti'
import { BadgeEstensione, dataBreve } from './EstensioniSupporto'

/**
 * The CI page's «Contratti» section: the contracts that cover its asset, and
 * the extended support that keeps its software or system supported past the
 * producer's date (so its end-of-support finding is not «fuori supporto»).
 * Shown only when there is something to show. See support_extension_service.del_ci.
 */
export function ContrattiDelCi({ dati }: { dati: CiContracts }) {
  return (
    <Card title={t('Contratti')}>
      {dati.contracts.length > 0 && (
        <ul className="elenco-semplice">
          {dati.contracts.map((c) => (
            <li key={c.id}>
              <Link to={`/contracts/${c.id}`}><strong>{c.reference}</strong></Link>
              {c.name ? ` · ${c.name}` : ''} · {c.vendor} · {etichettaTipoContratto(c.contract_type)}{' '}
              <BadgeStatoContratto stato={c.effective_status} />
              {c.end_date && <span className="muted"> · {t('scade il {d}', { d: dataBreve(c.end_date) })}</span>}
              {c.covered_until && <span className="muted"> · {t('coperto fino al {d}', { d: dataBreve(c.covered_until) })}</span>}
            </li>
          ))}
        </ul>
      )}
      {dati.contracts.length === 0 && dati.asset_id === null && (
        <p className="field__hint">{t('Il CI non è registrato come bene: i contratti coprono i beni, ma un’estensione del supporto può scegliere anche i CI.')}</p>
      )}
      {dati.extensions.length > 0 && (
        <>
          <h4 className="ruoli__titoletto">{t('Supporto esteso')}</h4>
          <ul className="elenco-semplice">
            {dati.extensions.map((e) => (
              <li key={e.id}>
                <strong>{e.label}</strong>{e.cycle ? ` ${e.cycle}` : ''} · {t('fino al {d}', { d: dataBreve(e.effective_until ?? e.until) })}{' '}
                <BadgeEstensione e={e} /> · <Link to={`/contracts/${e.contract_id}`}>{e.contract_reference}</Link>
              </li>
            ))}
          </ul>
          <p className="field__hint">{t('Finché vale, il fine supporto di questo CI non conta come rischio aperto: torna da solo alla fine dell’estensione o del contratto.')}</p>
        </>
      )}
    </Card>
  )
}
